import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-text-area-input',
    templateUrl: './text-area-input.component.html',
    styleUrls: ['./text-area-input.component.scss'],
    standalone: false
})
export class TextAreaInputComponent {
  @Input() dataTestId: string;
  @Input() errorMessage: string;
  @Input() formControlRef: FormControl;
  @Input() isFullWidth: boolean;
  @Input() label: string;
  @Input() maxLength?: number;
  @Input() placeholder: string;
}
